import React from "react";
import "./revenue.css";
import * as FeatherIcon from 'react-feather';


export default function SectionHeader({ title, subtitle, view, onChangeView }) {
  return (
    <div className="section-head">
      <div>
        <div className="section-title">{title}</div>
        <div className="section-sub">{subtitle}</div>
      </div>

      <div className="d-flex align-items-center gap-2">
        {/* Segmented control */}
        <div className="seg-switch" role="group" aria-label="View switch">
          <button
            type="button"
            className={`seg-btn ${view === "table" ? "is-active" : ""}`}
            onClick={() => onChangeView?.("table")}
          >
                <FeatherIcon.Table width={14} className="me-1" />
            Tabular View
          </button>
          <button
            type="button"
            className={`seg-btn ${view === "visual" ? "is-active" : ""}`}
            onClick={() => onChangeView?.("visual")}
          >
                <FeatherIcon.PieChart width={14} className="me-1" />
            Visual View
          </button>
        </div>

        {/* Reset appears only when Visual is active */}
        {view === "visual" && (
          <button
            type="button"
            className="seg-reset"
            onClick={() => onChangeView?.("table")}
          >
            <i className="ri-refresh-line me-1" />
            Reset
          </button>
        )}
      </div>
    </div>
  );
}
